<script>
  export default {
    methods: {
      bookingPeriodLabel (obj, includePeriodName = true) {
        let labelName = includePeriodName ? `${obj.name} (` : ''
        if (obj.days) {
          labelName = labelName + this.$t('table.booking_periods.days_label', { days: obj.days })
        } if (obj.weeks) {
          labelName = labelName + `${obj.days ? ', ' : ''}${this.$t('table.booking_periods.weeks_label', { weeks: obj.weeks })}`
        } if (obj.months) {
          labelName = labelName + `${obj.days || obj.weeks ? ', ' : ''}${this.$t('table.booking_periods.months_label', { months: obj.months })}`
        }
        if (includePeriodName) {
          labelName = labelName + ')'
        }
        return labelName
      },
    }
  }
</script>
